<template>
  <v-app>
    <!-- <v-navigation-drawer app v-model="$store.state.drawer" temporary width="300"> -->
    <v-navigation-drawer app v-model="$store.state.drawer" temporary width="300">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img v-if="photoURL" :src="photoURL" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ userName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-for="(item, index) in items" :key="index" :to="item.link">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon v-if="$store.state.login_user" @click="toggleSideMenu"></v-app-bar-nav-icon>
      <v-toolbar-title>在庫管理アプリ ver2.2.0</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="$store.state.login_user" @click="logout">ログアウト</v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./main";

export default {
  name: "App",
  created() {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.setUserData(user);
      } else {
        this.resetUserData();
      }
    });
  },
  data() {
    return {
      items: [
        { title: "在庫管理アプリについて", icon: "mdi-package-variant-closed", link: { name: "about" } },
        { title: "カテゴリマスタ", icon: "mdi-package-variant-closed", link: { name: "categories" } },
        { title: "品目マスタ", icon: "mdi-package-variant-closed", link: { name: "items" } },
        { title: "保管場所マスタ", icon: "mdi-package-variant-closed", link: { name: "locations" } },
        { title: "在庫一覧", icon: "mdi-package-variant-closed", link: { name: "inventries" } },
        { title: "履歴", icon: "mdi-package-variant-closed", link: { name: "histories" } },
      ],
    };
  },
  computed: {
    ...mapGetters(["userName", "photoURL", "itemLength"]),
  },
  methods: {
    async setUserData(user) {
      await this.setLoginUser(user);
      await this.addUser();
      await this.fetchCategories();
      await this.fetchItems();
      await this.fetchLocations();
      await this.fetchInventories();
      await this.fetchHistories();
      if (this.$router.currentRoute.name === "home" || this.$router.currentRoute.name === "loading") {
        if (this.itemLength === 0) {
          this.$router.push({ name: "about" });
        } else {
          this.$router.push({ name: "inventries" });
        }
      }
    },
    async resetUserData() {
      await this.deleteLoginUser();
      this.$router.push({ name: "home" });
    },
    ...mapActions(["toggleSideMenu", "setLoginUser", "deleteLoginUser", "fetchCategories", "fetchItems", "fetchLocations", "fetchInventories", "fetchHistories", "addUser", "logout"]),
  },
};
</script>
